module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jQ1BA"))).then(() => module.bundle.root('8rm4T'));